export const mapboxStyleURL = 'mapbox://styles/mapbox/light-v11'
export const mapDefaultZoom = 13
export const mapMaxZoom = 15
export const mapCameraAnimationDuration = 300
export const mapActiveFramesPerSecond = 30
export const mapPausedFramesPerSecond = 1
// Clusters disappear at the next integer zoom, which the camera must be able to reach.
export const mapClusterMaxZoom = mapMaxZoom - 1
